import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'
import { indexedDB } from './_helpers/indexedDB'
import Loader from '@/components/Loader'
import Notifications from 'vue-notification'

// import Clipboard from 'v-clipboard'

// Vue.use(Clipboard)
Vue.use(Notifications)

window.idb = indexedDB

import {
  // Directives
  VTooltip,
  VClosePopper,
  // Components
  Menu,
  Dropdown,
} from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popper', VClosePopper)
Vue.component('VDropdown', Dropdown)
Vue.component('VMenu', Menu)
Vue.component('Loader', Loader)

import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'v-tooltip/dist/v-tooltip.css'

import { store } from './_store'
import { router } from './_helpers'
import App from './App.vue'
import { consultFormService } from './_services'

import { Validator } from 'vee-validate'

Validator.extend('not_previous_report_data', {
  getMessage: (field) => `The ${field} value needs review.`,
  validate: (value) => !(value || '').startsWith('(previous report)'),
})

window.vee = VeeValidate
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    invalid: 'alert-danger',
  },
  dictionary: {
    en: {
      attributes: {
        regulation_email_receivers: 'Email address',
      },
      messages: {
        date_between: () => 'Date must be within the current season.',
      },
    },
  },
})

Vue.use(VueMoment)

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'production') {
  Vue.config.errorHandler = function (err, vm, info) {
    let data = {
      date: Date.now(),
      email: JSON.parse(localStorage.user).email || '',
      state: vm.$store.state,
      error: { name: err.name, message: err.message, stack: err.stack },
      info: info,
      url: window.location.href,
      assets: Array.from(document.querySelectorAll('script')).map((a) => a.src),
    }

    if (window.navigator.onLine) {
      return consultFormService.errorTrack([data])
    } else {
      indexedDB
        .get('errors', 'errors')
        .then((errors) => {
          errors.push(data)
          indexedDB.set('errors', errors, 'errors')
        })
        .catch(() => {
          // initialize indexedDB
          indexedDB.set('errors', [data], 'errors')
        })
    }
  }
}

const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
  created() {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('online', this.syncErrors)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('online', this.syncErrors)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    updateOnlineStatus: function (event) {
      store.dispatch('connection/setConnected', event.type == 'online')
    },
    syncErrors: function () {
      indexedDB.get('errors', 'errors').then((errors) => {
        consultFormService.errorTrack(errors).then(() => indexedDB.set('errors', []))
      })
    },
  },
}).$mount('#app')

window.kapp = app

// if (process.env === 'production')
// {
//     window.app = app
// }
